import { Space } from 'antd';
import { SpaceProps } from 'antd/es/space';
import React from 'react';
import { User } from '@/models/user';

export enum MobileDisplayMode {
  None,
  Short,
  Full,
}

export type Props = {
  user: User;
  spaceProps?: SpaceProps;
  showRemarkName?: boolean;
  showNickName?: boolean;
  showMobile?: MobileDisplayMode;
};

const UserName: React.FC<Props> = ({
  user,
  spaceProps = {},
  showRemarkName = true,
  showNickName = true,
  showMobile = MobileDisplayMode.None,
}: Props) => {
  if (!user) return <>无客户信息</>;

  let userName = user.nickname;
  if (!userName) {
    // if (user.weixinOpenid && user.alipayId) {
    //   userName = '微信/支付宝匿名用户';
    // } else if (user.alipayId) {
    //   userName = '支付宝匿名用户';
    // } else if (user.weixinOpenid) {
    //   userName = '微信匿名用户';
    // } else {
    //   userName = '匿名用户';
    // }
    userName = '匿名用户';
  }

  let remarkName = user.remarkName;
  if (showNickName && remarkName) {
    remarkName = `(${remarkName})`;
  }

  let mobile = user.mobile;
  if (mobile) {
    if (showMobile === MobileDisplayMode.None) {
      mobile = '';
    } else if (showMobile === MobileDisplayMode.Short) {
      mobile = mobile.slice(-4);
    }
  }

  return (
    <Space size={1} direction="horizontal" {...spaceProps}>
      {showNickName && <>{userName}</>}
      {showRemarkName && <>{remarkName}</>}
      {mobile ? <>{mobile}</> : null}
    </Space>
  );
};

export default UserName;
